import { ComponentBase } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Container extends ComponentBase<HTMLElement>
{
    constructor(...inside: appendable[])
    {
        super("div");

        this.Class("container");

        this.Append(...inside);
    }
}
